interface ActionTypes {
  GET_ENQUIRIES_START: string;
  GET_ENQUIRIES_SUCCESS: string;
  GET_ENQUIRIES_FAILURE: string;
  SEARCH_JOB_ID_USER_REF_START: string;
  SEARCH_JOB_ID_USER_REF_SUCCESS: string;
  SEARCH_JOB_ID_USER_REF_FAILURE: string;
  GET_TEAM_ENQUIRER_LIST_START: string;
  GET_TEAM_ENQUIRER_LIST_SUCCESS: string;
  GET_TEAM_ENQUIRER_LIST_FAILURE: string;
  GET_CREDENTIAL_START: string;
  GET_CREDENTIAL_SUCCESS: string;
  GET_CREDENTIAL_FAILURE: string;
}

export const HomeActionTypes: ActionTypes = {
  GET_ENQUIRIES_START: '@@GET_ENQUIRIES_START',
  GET_ENQUIRIES_SUCCESS: '@@GET_ENQUIRIES_SUCCESS',
  GET_ENQUIRIES_FAILURE: '@@GET_ENQUIRIES_FAILURE',
  SEARCH_JOB_ID_USER_REF_START: '@@SEARCH_JOB_ID_USER_REF_START',
  SEARCH_JOB_ID_USER_REF_SUCCESS: '@@SEARCH_JOB_ID_USER_REF_SUCCESS',
  SEARCH_JOB_ID_USER_REF_FAILURE: '@@SEARCH_JOB_ID_USER_REF_FAILURE',
  GET_TEAM_ENQUIRER_LIST_START: '@@GET_TEAM_ENQUIRER_LIST_START',
  GET_TEAM_ENQUIRER_LIST_SUCCESS: '@@GET_TEAM_ENQUIRER_LIST_SUCCESS',
  GET_TEAM_ENQUIRER_LIST_FAILURE: '@@GET_TEAM_ENQUIRER_LIST_FAILURE',
  GET_CREDENTIAL_START: '@@GET_CREDENTIAL_START',
  GET_CREDENTIAL_SUCCESS: '@@GET_CREDENTIAL_SUCCESS',
  GET_CREDENTIAL_FAILURE: '@@GET_CREDENTIAL_FAILURE'
};

export interface HomeState {
  enquiries?: any;
  isLoading?: boolean;
  searchJobIdUserRefData?: any;
  isSearchingJobIdUserRef?: boolean;
  teamEnquirerList?: any;
  isLoadingTeamEnquirer?: boolean;
  credentials?: { token: string; username: string };
  state: 'loading' | 'success' | 'fail';
  error?: string;
}
